import React, { useEffect, useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { FaSave, FaTimes, FaSpinner, FaExclamationTriangle } from 'react-icons/fa';
import './HRPoliciesEditModal.scss';

const isRichTextEmpty = (value) => {
  const plainText = String(value || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
  return plainText.length === 0;
};

const editorModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['blockquote', 'link'],
    ['clean'],
  ],
};

const editorFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
  'align',
  'blockquote',
  'link',
];

const HRPoliciesEditModal = ({ initialContent, onClose, onSave }) => {
  const [content, setContent] = useState(initialContent || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setContent(initialContent || '');
  }, [initialContent]);

  const handleSave = async () => {
    if (isRichTextEmpty(content)) {
      setError('Content cannot be empty.');
      return;
    }

    try {
      setSaving(true);
      setError(null);
      
      // Update the HR Policies content in Firebase
      const docRef = doc(db, 'authUsers', 'webPages');
      await updateDoc(docRef, {
        hrPolicyPage: content
      });
      
      // Call the onSave callback with the updated content
      onSave(content);
      setSaving(false);
    } catch (err) {
      console.error('Error saving HR policy content:', err);
      setError('Failed to save changes. Please try again.');
      setSaving(false);
    }
  };

  return (
    <div className="hr-policies-modal-overlay">
      <div className="hr-policies-modal">
        <div className="modal-header">
          <h2>Edit HR Policies</h2>
          <button 
            className="close-button"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        {error && (
          <div className="error-message">
            <FaExclamationTriangle className="error-icon" />
            <p>{error}</p>
          </div>
        )}

        <div className="modal-content">
          <p className="modal-description">
            Edit the HR policies content below. Changes will be published immediately upon saving.
          </p>
          <div className="editor-container">
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              modules={editorModules}
              formats={editorFormats}
              placeholder="Write HR policies content here..."
            />
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="cancel-button"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button 
            className="save-button"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <FaSpinner className="spinner" /> Saving...
              </>
            ) : (
              <>
                <FaSave /> Save Changes
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HRPoliciesEditModal; 